import stili from '../competenze/stili';
import { TIPI_TRASFORMAZIONE, ALTRO, leggiTipoTrasformazione, scriviTipoTrasformazione } from '../../utils/campiScadenza';

// Tipo di trasformazione: menu con le voci dell'elenco e "Altro" con testo libero. Il valore è il testo salvato.
export default function CampoTipoTrasformazione({ id, valore, onCambia, etichetta = 'Tipo di trasformazione', daControllare = false, avviso = '' }) {
  const { scelta, testo } = leggiTipoTrasformazione(valore);
  return (
    <div style={{ ...stili.campo, ...(daControllare ? { background: '#fff7ed', border: '1px solid #fdba74', borderRadius: '6px', padding: '0.4rem 0.6rem' } : {}) }}>
      <label style={stili.label} htmlFor={id}>{etichetta}</label>
      <select id={id} value={scelta} onChange={e => onCambia(scriviTipoTrasformazione(e.target.value, e.target.value === ALTRO ? testo : ''))} style={stili.input}>
        <option value="">—</option>
        {TIPI_TRASFORMAZIONE.map(t => <option key={t} value={t}>{t}</option>)}
        <option value={ALTRO}>{ALTRO}</option>
      </select>
      {scelta === ALTRO && (
        <input value={testo} maxLength={180} placeholder="Descrivi la trasformazione" aria-label={`${etichetta}: testo`}
          onChange={e => onCambia(scriviTipoTrasformazione(ALTRO, e.target.value))} style={{ ...stili.input, marginTop: '0.3rem' }} />
      )}
      {avviso && <small style={{ color: '#9a3412' }}>{avviso}</small>}
    </div>
  );
}
